import React from 'react';
import { useLocation, Link } from 'react-router-dom';
export function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  return <nav className="text-base" data-id="element-593">
      <ol className="flex items-center space-x-2" data-id="element-594">
        <li data-id="element-595">
          <Link to="/" className="text-blue-600 hover:text-blue-800" data-id="element-596">
            Home
          </Link>
        </li>
        {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        return <li key={name} className="flex items-center" data-id="element-597">
              <span className="mx-2 text-neutral-400" data-id="element-598">/</span>
              {isLast ? <span className="text-neutral-600 font-medium" data-id="element-599">
                  {name.charAt(0).toUpperCase() + name.slice(1)}
                </span> : <Link to={routeTo} className="text-blue-600 hover:text-blue-800" data-id="element-600">
                  {name.charAt(0).toUpperCase() + name.slice(1)}
                </Link>}
            </li>;
      })}
      </ol>
    </nav>;
}